import { render, staticRenderFns } from "./parent_page_self_service_v2.vue?vue&type=template&id=3494b128&"
import script from "./parent_page_self_service_v2.vue?vue&type=script&lang=js&"
export * from "./parent_page_self_service_v2.vue?vue&type=script&lang=js&"
import style0 from "./parent_page_self_service_v2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports